import React, { useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDownIcon, MenuIcon, XIcon } from 'lucide-react';
const navItems = [{
  name: '产品与服务',
  path: '/products',
  description: '我们提供全面的AI技术产品和服务,包括大模型平台、异构算力服务和开发工具,满足企业在数字化转型中的各种需求。',
  submenu: [{
    name: 'PH8 大模型MaaS平台',
    path: '/products/ph8',
    description: '提供大规模语言模型即服务,支持自然语言处理和内容生成'
  }, {
    name: '普华云 异构算力服务平台',
    path: '/products/cloud',
    description: '整合多种计算资源,提供高性能异构算力服务'
  }, {
    name: '万里 大模型开发平台',
    path: '/products/wanli',
    description: '一站式大模型开发环境,简化训练和部署流程'
  }]
}, {
  name: '解决方案',
  path: '/solutions',
  description: '针对不同行业和场景,我们提供定制化的AI解决方案,包括一体机、具身智能和国产AI芯片等多种方案,助力企业实现智能化转型。',
  submenu: [{
    name: '一体机解决方案',
    path: '/solutions/all-in-one',
    submenu: [{
      name: '智能办公一体机解决方案',
      path: '/solutions/all-in-one/office',
      description: '集成办公场景的智能化解决方案'
    }, {
      name: 'Deepseek一体机解决方案',
      path: '/solutions/all-in-one/deepseek',
      description: '基于Deepseek模型的一体化部署方案'
    }, {
      name: '代码生成一体机解决方案',
      path: '/solutions/all-in-one/code',
      description: '专注于代码生成和开发辅助的智能系统'
    }]
  }, {
    name: '具身智能解决方案',
    path: '/solutions/embodied',
    submenu: [{
      name: '具深智能仿真平台',
      path: '/solutions/embodied/simulation',
      description: '提供完整的机器人仿真和测试环境'
    }, {
      name: '人形机器人解决方案',
      path: '/solutions/embodied/humanoid',
      description: '为人形机器人提供感知、决策和执行能力'
    }]
  }, {
    name: '国产AI芯片解决方案',
    path: '/solutions/chips',
    submenu: [{
      name: '四足机器狗解决方案',
      path: '/solutions/chips/robot-dog',
      description: '基于国产芯片的四足机器人控制系统'
    }, {
      name: '国产化AI芯片性能测试解决方案',
      path: '/solutions/chips/performance',
      description: '全面的AI芯片性能评估和测试工具'
    }, {
      name: '国产化异构集群解决方案',
      path: '/solutions/chips/cluster',
      description: '构建高性能的国产化异构计算集群'
    }]
  }]
}, {
  name: '成功案例',
  path: '/cases',
  description: '我们已成功帮助众多知名企业实现数字化转型,涵盖金融、制造、互联网等多个行业,提供从咨询到实施的全方位服务。',
  submenu: [{
    name: '大模型服务应用案例',
    path: '/cases/llm',
    submenu: [{
      name: '案例一',
      path: '/cases/llm/case1',
      description: '大型企业智能客服系统部署案例'
    }, {
      name: '案例二',
      path: '/cases/llm/case2',
      description: '金融行业智能风控系统应用'
    }, {
      name: '案例三',
      path: '/cases/llm/case3',
      description: '教育领域个性化学习助手实践'
    }]
  }, {
    name: '异构算力综合服务案例',
    path: '/cases/computing',
    submenu: [{
      name: '案例一',
      path: '/cases/computing/case1',
      description: '大规模AI训练集群部署与优化'
    }]
  }, {
    name: '一体机服务应用案例',
    path: '/cases/all-in-one',
    submenu: [{
      name: '案例一',
      path: '/cases/all-in-one/case1',
      description: '企业级智能办公系统落地实施'
    }]
  }, {
    name: 'AI芯片性能测试案例',
    path: '/cases/chip-testing',
    submenu: [{
      name: '案例一',
      path: '/cases/chip-testing/case1',
      description: '国产AI芯片全面性能评估'
    }, {
      name: '案例二',
      path: '/cases/chip-testing/case2',
      description: '异构芯片协同计算优化案例'
    }]
  }]
}, {
  name: '关于我们',
  path: '/about',
  description: '专注AI技术创新与应用,致力于为企业提供领先的人工智能解决方案。我们拥有顶尖的技术团队和丰富的行业经验。',
  submenu: [{
    name: '企业介绍',
    path: '/about/company',
    description: '了解我们的发展历程和企业文化'
  }, {
    name: '团队介绍',
    path: '/about/team',
    description: '认识我们的专业技术团队'
  }, {
    name: '企业文化',
    path: '/about/culture',
    description: '探索我们的核心价值观和文化理念'
  }, {
    name: '资质证书',
    path: '/about/certificates',
    description: '查看我们的专业认证和荣誉资质'
  }, {
    name: '加入我们',
    path: '/about/join',
    description: '与我们一起创造AI技术的未来'
  }, {
    name: '联系我们',
    path: '/about/contact',
    description: '随时与我们取得联系'
  }]
}];
const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeMenus, setActiveMenus] = useState<string[]>([]);
  const [hoveredMenu, setHoveredMenu] = useState<string | null>(null);
  const closeTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const location = useLocation();
  const handleMouseEnter = (menuName: string) => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setHoveredMenu(menuName);
  };
  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setHoveredMenu(null);
    }, 200);
  };
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const toggleSubmenu = (name: string) => {
    if (activeMenus.includes(name)) {
      setActiveMenus(activeMenus.filter(item => item !== name));
    } else {
      setActiveMenus([...activeMenus, name]);
    }
  };
  const isSubmenuActive = (name: string) => {
    return activeMenus.includes(name);
  };
  return <header className="backdrop-blur-md bg-white/95 shadow-sm sticky top-0 z-50" data-id="element-174">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <div className="flex justify-between items-center py-4" data-id="element-176">
          <div className="flex items-center" data-id="element-177">
            <Link to="/" className="flex items-center space-x-2" data-id="element-178">
              <div className="w-10 h-10 bg-gradient-to-r from-primary-600 to-secondary-600 rounded-md flex items-center justify-center shadow-lg" data-id="element-179">
                <span className="text-white font-bold text-xl" data-id="element-180">AI</span>
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-primary-600 to-secondary-600 bg-clip-text text-transparent" data-id="element-181">
                科技企业
              </span>
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-182">
            {navItems.map(item => <div key={item.name} className="relative" onMouseEnter={() => handleMouseEnter(item.name)} onMouseLeave={handleMouseLeave} data-id="element-183">
                <Link to={item.path} className={`text-base font-medium transition-all duration-300 ${location.pathname.startsWith(item.path) ? 'text-primary-600' : 'text-gray-700 hover:text-primary-500'} flex items-center py-2`} data-id="element-184">
                  {item.name}
                  {item.submenu && <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-185" />}
                </Link>
                {/* Full-width Mega Menu */}
                {item.submenu && hoveredMenu === item.name && <div className="fixed left-0 right-0 top-full z-50" onMouseEnter={() => handleMouseEnter(item.name)} onMouseLeave={handleMouseLeave} data-id="element-186">
                    <div className="bg-gradient-to-br from-white/95 via-primary-50/60 to-secondary-50/60 backdrop-blur-xl shadow-2xl border-t border-primary-100/50" data-id="element-187">
                      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-188">
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-189">
                          {/* Left side - Introduction */}
                          <div className="lg:col-span-1 relative" data-id="element-190">
                            <div className="sticky top-8" data-id="element-191">
                              <div className="inline-block px-4 py-2 bg-gradient-to-r from-primary-500 to-secondary-500 rounded-full mb-4" data-id="element-192">
                                <span className="text-white text-sm font-semibold" data-id="element-193">
                                  探索更多
                                </span>
                              </div>
                              <h3 className="text-2xl font-bold bg-gradient-to-r from-primary-600 via-primary-700 to-secondary-600 bg-clip-text text-transparent mb-4 leading-tight" data-id="element-194">
                                {item.name}
                              </h3>
                              <p className="text-gray-600 leading-relaxed mb-6 text-base" data-id="element-195">
                                {item.description}
                              </p>
                              <Link to={item.path} className="inline-flex items-center px-5 py-2.5 bg-gradient-to-r from-primary-600 to-secondary-600 text-white font-semibold rounded-lg hover:shadow-xl hover:scale-105 transition-all duration-300 group/link" data-id="element-196">
                                查看全部
                                <svg className="w-5 h-5 ml-2 transform group-hover/link:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-197">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-198" />
                                </svg>
                              </Link>
                            </div>
                          </div>
                          {/* Right side - Menu items */}
                          <div className="lg:col-span-2" data-id="element-199">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-200">
                              {item.submenu.map(subItem => <div key={subItem.name} className="bg-white/90 backdrop-blur-sm rounded-xl p-5 shadow-md hover:shadow-xl transition-all duration-300 hover:scale-[1.02] border border-gray-100/50" data-id="element-201">
                                  <Link to={subItem.path} className="block group/item" data-id="element-202">
                                    <div className="flex items-start justify-between mb-2" data-id="element-203">
                                      <h4 className="text-base font-bold text-gray-900 group-hover/item:text-primary-600 transition-colors duration-300 flex items-center" data-id="element-204">
                                        {subItem.name}
                                        {subItem.submenu && <ChevronDownIcon className="ml-2 h-4 w-4 text-primary-500" data-id="element-205" />}
                                      </h4>
                                    </div>
                                    {subItem.description && <p className="text-sm text-gray-600 group-hover/item:text-gray-800 transition-colors duration-300 mb-3" data-id="element-206">
                                        {subItem.description}
                                      </p>}
                                  </Link>
                                  {/* Sub-submenu items */}
                                  {subItem.submenu && <div className="space-y-1.5 mt-3 pt-3 border-t border-gray-200/50" data-id="element-207">
                                      {subItem.submenu.map(subSubItem => <Link key={subSubItem.name} to={subSubItem.path} className="block group/subitem p-2.5 rounded-lg hover:bg-gradient-to-r hover:from-primary-50 hover:to-secondary-50 transition-all duration-300" data-id="element-208">
                                          <div className="flex items-center justify-between" data-id="element-209">
                                            <div className="flex-1" data-id="element-210">
                                              <div className="text-sm font-semibold text-gray-800 group-hover/subitem:text-primary-600 transition-colors duration-300 mb-0.5" data-id="element-211">
                                                {subSubItem.name}
                                              </div>
                                              {subSubItem.description && <p className="text-xs text-gray-500 group-hover/subitem:text-gray-700 transition-colors duration-300 line-clamp-2" data-id="element-212">
                                                  {subSubItem.description}
                                                </p>}
                                            </div>
                                            <svg className="w-4 h-4 text-gray-400 group-hover/subitem:text-primary-600 transform group-hover/subitem:translate-x-1 transition-all duration-300 flex-shrink-0 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-213">
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-214" />
                                            </svg>
                                          </div>
                                        </Link>)}
                                    </div>}
                                </div>)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>)}
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-215">
            <button onClick={toggleMobileMenu} className="text-gray-700 hover:text-primary-500 focus:outline-none transition-all duration-300" data-id="element-216">
              {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-217" /> : <MenuIcon className="h-6 w-6" data-id="element-218" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMobileMenuOpen && <nav className="md:hidden backdrop-blur-md bg-white/95" data-id="element-219">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 max-h-[80vh] overflow-y-auto" data-id="element-220">
            {navItems.map(item => <div key={item.name} className="py-1" data-id="element-221">
                <div className="flex justify-between items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gradient-to-r hover:from-primary-50 hover:to-secondary-50 hover:text-primary-500 cursor-pointer transition-all duration-300" onClick={() => toggleSubmenu(item.name)} data-id="element-222">
                  <Link to={item.path} data-id="element-223">{item.name}</Link>
                  {item.submenu && <ChevronDownIcon className={`h-5 w-5 transition-transform duration-300 ${isSubmenuActive(item.name) ? 'rotate-180' : ''}`} data-id="element-224" />}
                </div>
                {item.submenu && isSubmenuActive(item.name) && <div className="pl-4" data-id="element-225">
                    {item.submenu.map(subItem => <div key={subItem.name} className="py-1" data-id="element-226">
                        <div className="flex justify-between items-center px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:bg-gradient-to-r hover:from-primary-50 hover:to-secondary-50 hover:text-primary-500 cursor-pointer transition-all duration-300" onClick={() => toggleSubmenu(subItem.name)} data-id="element-227">
                          <Link to={subItem.path} data-id="element-228">{subItem.name}</Link>
                          {subItem.submenu && <ChevronDownIcon className={`h-4 w-4 transition-transform duration-300 ${isSubmenuActive(subItem.name) ? 'rotate-180' : ''}`} data-id="element-229" />}
                        </div>
                        {subItem.submenu && isSubmenuActive(subItem.name) && <div className="pl-4" data-id="element-230">
                            {subItem.submenu.map(subSubItem => <Link key={subSubItem.name} to={subSubItem.path} className="block px-3 py-2 rounded-md text-xs font-medium text-gray-500 hover:bg-gradient-to-r hover:from-primary-50 hover:to-secondary-50 hover:text-primary-500 transition-all duration-300" data-id="element-231">
                                {subSubItem.name}
                              </Link>)}
                          </div>}
                      </div>)}
                  </div>}
              </div>)}
          </div>
        </nav>}
    </header>;
};
export default Navbar;